import {
  ALL_STOCK_REQUESTING,
  ALL_STOCK_REQUEST_SUCCESS,
  ALL_STOCK_REQUEST_ERROR,
  SNAPSHOT_REQUESTING,
  SNAPSHOT_REQUEST_SUCCESS,
  SNAPSHOT_REQUEST_ERROR,
  STOCK_INFO_REQUESTING,
  STOCK_INFO_REQUEST_SUCCESS,
  STOCK_INFO_REQUEST_ERROR,
  ALL_ORD_REQUESTING,
  ALL_ORD_REQUEST_SUCCESS,
  ALL_ORD_REQUEST_ERROR,
  SNAPSHOT_PART_REQUESTING,
  SNAPSHOT_PART_REQUEST_SUCCESS,
  SNAPSHOT_PART_REQUEST_ERROR,
  CLEAR_PART_REQUEST,
  PT_LIST_REQUESTING,
  PT_LIST_REQUEST_SUCCESS,
  PT_LIST_REQUEST_ERROR,
  CW_LIST_REQUEST_SUCCESS,
  CW_LIST_REQUEST_ERROR,
  CW_LIST_REQUESTING,
  LIST_30_REQUESTING,
  LIST_30_REQUEST_SUCCESS,
  LIST_30_REQUEST_ERROR,
  LIST_MESSAGE_REQUESTING,
  LIST_MESSAGE_REQUEST_SUCCESS,
  LIST_MESSAGE_REQUEST_ERROR,
  BRANCH_CODE_REQUEST_SUCCESS,
  BRANCH_CODE_REQUESTING,
  BRANCH_CODE_REQUEST_ERROR,
  SUMMARY_REQUESTING,
  SUMMARY_REQUEST_SUCCESS,
  SUMMARY_REQUEST_ERROR,
  NOI_CAP_REQUESTING,
  NOI_CAP_REQUEST_SUCCESS,
  NOI_CAP_REQUEST_ERROR,
  GET_STOCK_BY_ID_REQUESTING,
  GET_STOCK_BY_ID_REQUEST_SUCCESS,
  GET_STOCK_BY_ID_REQUEST_ERROR,
  INDEX_REQUESTING,
  INDEX_REQUEST_SUCCESS,
  INDEX_REQUEST_ERROR,
  WORLD_INDEX_REQUESTING,
  WORLD_INDEX_REQUEST_SUCCESS,
  WORLD_INDEX_REQUEST_ERROR,
  PS_LIST_REQUESTING,
  PS_LIST_REQUEST_SUCCESS,
  PS_LIST_REQUEST_ERROR,
  PS_SNAPSHOT_REQUESTING,
  PS_SNAPSHOT_REQUEST_ERROR,
  PS_SNAPSHOT_REQUEST_SUCCESS,
  NDATA_SNAPSHOT_REQUESTING,
  NDATA_SNAPSHOT_REQUEST_SUCCESS,
  NDATA_SNAPSHOT_REQUEST_ERROR,
  TRADE_HIS_PS_REQUEST_SUCCESS,
  TRADE_HIS_PS_REQUEST_ERROR,
  TRADE_HIS_PS_REQUESTING,
  TRADE_HIS_PS_Add_ROW,
  DM_NGANH_REQUEST_SUCCESS,
  DM_NGANH_REQUEST_ERROR,
  DM_NGANH_REQUESTING,
  LIST_ETF_REQUESTING,
  LIST_ETF_REQUEST_ERROR,
  LIST_ETF_REQUEST_SUCCESS,
  CLEAR_SNAPSHOT_REQUEST,
  LOLE_SNAPSHOT_REQUESTING,
  LOLE_SNAPSHOT_REQUEST_SUCCESS,
  LOLE_SNAPSHOT_REQUEST_ERROR,
  SORT_TYPE,
  PS_INDEX_REQUESTING,
  PS_INDEX_REQUEST_SUCCESS,
  PS_INDEX_REQUEST_ERROR,
  SNAPSHOT_UNDERLYING_REQUESTING,
  SNAPSHOT_UNDERLYING_REQUEST_SUCCESS,
  SNAPSHOT_UNDERLYING_REQUEST_ERROR,
  MARGIN_LIST_REQUESTING,
  MARGIN_LIST_REQUEST_SUCCESS,
  MARGIN_LIST_REQUEST_ERROR,
  LOLE_HSX_SNAPSHOT_REQUESTING,
  LOLE_HSX_SNAPSHOT_REQUEST_SUCCESS,
  LOLE_HSX_SNAPSHOT_REQUEST_ERROR,
  TOP_INTEREST_REQUESTING,
  TOP_INTEREST_REQUEST_SUCCESS,
  TOP_INTEREST_REQUEST_ERROR,
  TOP_VOLUME_REQUESTING,
  TOP_VOLUME_SUCCESS,
  TOP_VOLUME_ERROR,
  BOND_LIST_REQUESTING,
  BOND_LIST_REQUEST_ERROR,
  BOND_LIST_REQUEST_SUCCESS,
} from './constants';

export const allStockRequest = function allStockRequest() {
  return {
    type: ALL_STOCK_REQUESTING,
  };
};

export const allStockRequestSuccess = function allStockRequestSuccess(
  allStock
) {
  return {
    type: ALL_STOCK_REQUEST_SUCCESS,
    allStock,
  };
};

export const allStockRequestError = function allStockRequestError(error) {
  return {
    type: ALL_STOCK_REQUEST_ERROR,
    error,
  };
};

export const marginListRequest = function marginListRequest() {
  return {
    type: MARGIN_LIST_REQUESTING,
  };
};

export const marginListRequestSuccess = function marginListRequestSuccess(
  marginList
) {
  return {
    type: MARGIN_LIST_REQUEST_SUCCESS,
    marginList,
  };
};

export const marginListRequestError = function marginListRequestError(error) {
  return {
    type: MARGIN_LIST_REQUEST_ERROR,
    error,
  };
};

export const listMessageRequest = function listMessageRequest() {
  return {
    type: LIST_MESSAGE_REQUESTING,
  };
};

export const listMessageRequestSuccess = function listMessageRequestSuccess(
  listMessage
) {
  return {
    type: LIST_MESSAGE_REQUEST_SUCCESS,
    listMessage,
  };
};

export const listMessageRequestError = function listMessageRequestError(error) {
  return {
    type: LIST_MESSAGE_REQUEST_ERROR,
    error,
  };
};

export const snapshotRequest = function snapshotRequest(data) {
  return {
    type: SNAPSHOT_REQUESTING,
    data,
  };
};

export const snapshotRequestSuccess = function snapshotRequestSuccess(
  dataList
) {
  return {
    type: SNAPSHOT_REQUEST_SUCCESS,
    dataList,
  };
};

export const snapshotRequestError = function snapshotRequestError(error) {
  return {
    type: SNAPSHOT_REQUEST_ERROR,
    error,
  };
};

export const snapshotUnderlyingCWRequest = function snapshotUnderlyingCWRequest(data) {
  return {
    type: SNAPSHOT_UNDERLYING_REQUESTING,
    data,
  };
};

export const snapshotUnderlyingCWSuccess = function snapshotUnderlyingCWSuccess(
  dataList
) {
  return {
    type: SNAPSHOT_UNDERLYING_REQUEST_SUCCESS,
    dataList,
  };
};

export const snapshotUnderlyingCWError = function snapshotUnderlyingCWError(error) {
  return {
    type: SNAPSHOT_UNDERLYING_REQUEST_ERROR,
    error,
  };
};

export const psSnapshotRequest = function psSnapshotRequest(data) {
  return {
    type: PS_SNAPSHOT_REQUESTING,
    data,
  };
};

export const psSnapshotRequestSuccess = function psSnapshotRequestSuccess(
  dataList
) {
  return {
    type: PS_SNAPSHOT_REQUEST_SUCCESS,
    dataList,
  };
};

export const psSnapshotRequestError = function psSnapshotRequestError(error) {
  return {
    type: PS_SNAPSHOT_REQUEST_ERROR,
    error,
  };
};

export const psIndexRequest = function psIndexRequest(data) {
  return {
    type: PS_INDEX_REQUESTING,
    data,
  };
};

export const psIndexRequestSuccess = function psIndexRequestSuccess(
  dataList
) {
  return {
    type: PS_INDEX_REQUEST_SUCCESS,
    dataList,
  };
};

export const psIndexRequestError = function psIndexRequestError(error) {
  return {
    type: PS_INDEX_REQUEST_ERROR,
    error,
  };
};

export const loleSnapshotRequest = function loleSnapshotRequest(data) {
  return {
    type: LOLE_SNAPSHOT_REQUESTING,
    data,
  };
};

export const loleSnapshotRequestSuccess = function loleSnapshotRequestSuccess(
  dataList
) {
  return {
    type: LOLE_SNAPSHOT_REQUEST_SUCCESS,
    dataList,
  };
};

export const loleSnapshotRequestError = function loleSnapshotRequestError(error) {
  return {
    type: LOLE_SNAPSHOT_REQUEST_ERROR,
    error,
  };
};

export const loleHSXSnapshotRequest = function loleHSXSnapshotRequest() {
  return {
    type: LOLE_HSX_SNAPSHOT_REQUESTING,
  };
};

export const loleHSXSnapshotRequestSuccess = function loleHSXSnapshotRequestSuccess(
  dataList
) {
  return {
    type: LOLE_HSX_SNAPSHOT_REQUEST_SUCCESS,
    dataList,
  };
};

export const loleHSXSnapshotRequestError = function loleHSXSnapshotRequestError(error) {
  return {
    type: LOLE_HSX_SNAPSHOT_REQUEST_ERROR,
    error,
  };
};

export const clearPartRequest = function clearPartRequest(data) {
  return {
    type: CLEAR_PART_REQUEST,
  };
};

export const clearSnapshotRequest = function clearSnapshotRequest(data) {
  return {
    type: CLEAR_SNAPSHOT_REQUEST,
  };
};

export const snapshotPartRequest = function snapshotPartRequest(data) {
  return {
    type: SNAPSHOT_PART_REQUESTING,
    data,
  };
};

export const snapshotPartRequestSuccess = function snapshotPartRequestSuccess(
  dataList
) {
  return {
    type: SNAPSHOT_PART_REQUEST_SUCCESS,
    dataList,
  };
};

export const snapshotPartRequestError = function snapshotPartRequestError(
  error
) {
  return {
    type: SNAPSHOT_PART_REQUEST_ERROR,
    error,
  };
};

export const stockInfoRequest = function stockInfoRequest(data) {
  return {
    type: STOCK_INFO_REQUESTING,
    data,
  };
};

export const stockInfoRequestSuccess = function stockInfoRequestSuccess(
  stockInfo
) {
  return {
    type: STOCK_INFO_REQUEST_SUCCESS,
    stockInfo,
  };
};

export const stockInfoRequestError = function stockInfoRequestError(error) {
  return {
    type: STOCK_INFO_REQUEST_ERROR,
    error,
  };
};

export const allOrdRequest = function allOrdRequest(data) {
  return {
    type: ALL_ORD_REQUESTING,
    data,
  };
};

export const allOrdRequestSuccess = function allOrdRequestSuccess(allOrder) {
  return {
    type: ALL_ORD_REQUEST_SUCCESS,
    allOrder,
  };
};

export const allOrdRequestError = function allOrdRequestError(error) {
  return {
    type: ALL_ORD_REQUEST_ERROR,
    error,
  };
};

export const ptListRequest = function ptListRequest() {
  return {
    type: PT_LIST_REQUESTING,
  };
};

export const ptListRequestSuccess = function ptListRequestSuccess(ptList) {
  return {
    type: PT_LIST_REQUEST_SUCCESS,
    ptList,
  };
};

export const ptListRequestError = function ptListRequestError(error) {
  return {
    type: PT_LIST_REQUEST_ERROR,
    error,
  };
};

export const psListRequest = function psListRequest() {
  return {
    type: PS_LIST_REQUESTING,
  };
};

export const psListRequestSuccess = function psListRequestSuccess(psList) {
  return {
    type: PS_LIST_REQUEST_SUCCESS,
    psList,
  };
};

export const psListRequestError = function psListRequestError(error) {
  return {
    type: PS_LIST_REQUEST_ERROR,
    error,
  };
};

export const list30Request = function list30Request(data) {
  return {
    type: LIST_30_REQUESTING,
    data,
  };
};

export const list30RequestSuccess = function list30RequestSuccess(list30) {
  return {
    type: LIST_30_REQUEST_SUCCESS,
    list30,
  };
};

export const list30RequestError = function list30RequestError(error) {
  return {
    type: LIST_30_REQUEST_ERROR,
    error,
  };
};

export const listEtfRequest = function listEtfRequest(data) {
  return {
    type: LIST_ETF_REQUESTING,
    data,
  };
};

export const listEtfRequestSuccess = function listEtfRequestSuccess(listEtf) {
  return {
    type: LIST_ETF_REQUEST_SUCCESS,
    listEtf,
  };
};

export const listEtfRequestError = function listEtfRequestError(error) {
  return {
    type: LIST_ETF_REQUEST_ERROR,
    error,
  };
};

export const cwListRequest = function cwListRequest() {
  return {
    type: CW_LIST_REQUESTING,
  };
};

export const cwListRequestSuccess = function cwListRequestSuccess(cwList) {
  return {
    type: CW_LIST_REQUEST_SUCCESS,
    cwList,
  };
};

export const cwListRequestError = function cwListRequestError(error) {
  return {
    type: CW_LIST_REQUEST_ERROR,
    error,
  };
};

export const bondListRequest = function bondListRequest() {
  return {
    type: BOND_LIST_REQUESTING,
  };
};

export const bondListRequestSuccess = function bondListRequestSuccess(resData) {
  return {
    type: BOND_LIST_REQUEST_SUCCESS,
    resData,
  };
};

export const bondListRequestError = function bondListRequestError(error) {
  return {
    type: BOND_LIST_REQUEST_ERROR,
    error,
  };
};

export const branchCodeRequest = function branchCodeRequest() {
  return {
    type: BRANCH_CODE_REQUESTING,
  };
};

export const branchCodeRequestSuccess = function branchCodeRequestSuccess(
  branchList
) {
  return {
    type: BRANCH_CODE_REQUEST_SUCCESS,
    branchList,
  };
};

export const branchCodeRequestError = function branchCodeRequestError(error) {
  return {
    type: BRANCH_CODE_REQUEST_ERROR,
    error,
  };
};

export const noicapRequest = function noicapRequest() {
  return {
    type: NOI_CAP_REQUESTING,
  };
};

export const noicapRequestSuccess = function noicapRequestSuccess(noicap) {
  return {
    type: NOI_CAP_REQUEST_SUCCESS,
    noicap,
  };
};

export const noicapRequestError = function noicapRequestError(error) {
  return {
    type: NOI_CAP_REQUEST_ERROR,
    error,
  };
};

export const indSumRequest = function indSumRequest() {
  return {
    type: SUMMARY_REQUESTING,
  };
};

export const indSumRequestSuccess = function indSumRequestSuccess(indSum) {
  return {
    type: SUMMARY_REQUEST_SUCCESS,
    indSum,
  };
};

export const indSumRequestError = function indSumRequestError(error) {
  return {
    type: SUMMARY_REQUEST_ERROR,
    error,
  };
};

export const getStockByIdRequest = function getStockByIdRequest(data) {
  return {
    type: GET_STOCK_BY_ID_REQUESTING,
    data,
  };
};

export const getStockByIdRequestSuccess = function getStockByIdRequestSuccess(
  dataList
) {
  return {
    type: GET_STOCK_BY_ID_REQUEST_SUCCESS,
    dataList,
  };
};

export const getStockByIdRequestError = function getStockByIdRequestError(
  error
) {
  return {
    type: GET_STOCK_BY_ID_REQUEST_ERROR,
    error,
  };
};

export const indexRequest = function indexRequest(data) {
  return {
    type: INDEX_REQUESTING,
    data,
  };
};

export const indexRequestSuccess = function indexRequestSuccess(indexList) {
  return {
    type: INDEX_REQUEST_SUCCESS,
    indexList,
  };
};

export const indexRequestError = function indexRequestError(error) {
  return {
    type: INDEX_REQUEST_ERROR,
    error,
  };
};

export const worldIndexRequest = function worldIndexRequest() {
  return {
    type: WORLD_INDEX_REQUESTING,
  };
};

export const worldIndexRequestSuccess = function worldIndexRequestSuccess(
  worldList
) {
  return {
    type: WORLD_INDEX_REQUEST_SUCCESS,
    worldList,
  };
};

export const worldIndexRequestError = function worldIndexRequestError(error) {
  return {
    type: WORLD_INDEX_REQUEST_ERROR,
    error,
  };
};

export const ndataSnapshotRequest = function ndataSnapshotRequest(data) {
  return {
    type: NDATA_SNAPSHOT_REQUESTING,
    data,
  };
};

export const ndataSnapshotRequestSuccess = function ndataSnapshotRequestSuccess(ndata) {
  return {
    type: NDATA_SNAPSHOT_REQUEST_SUCCESS,
    ndata,
  };
};

export const ndataSnapshotRequestError = function ndataSnapshotRequestError(error) {
  return {
    type: NDATA_SNAPSHOT_REQUEST_ERROR,
    error,
  };
};

export const tradeHisPsRequest = function tradeHisPsRequest(data) {
  return {
    type: TRADE_HIS_PS_REQUESTING,
    data,
  };
};

export const tradeHisPsRequestSuccess = function tradeHisPsRequestSuccess(dataList) {
  return {
    type: TRADE_HIS_PS_REQUEST_SUCCESS,
    dataList,
  };
};

export const tradeHisPsRequestError = function tradeHisPsRequestError(error) {
  return {
    type: TRADE_HIS_PS_REQUEST_ERROR,
    error,
  };
};

export const tradeHisPsAddRow = function tradeHisPsAddRow(data) {
  return {
    type: TRADE_HIS_PS_Add_ROW,
    data,
  };
};

export const sortTypeTbl = function sortTypeTbl(_type) {
  return {
    type: SORT_TYPE,
    _type,
  };
};


export const dmNganhRequest = function dmNganhRequest() {
  return {
    type: DM_NGANH_REQUESTING
  };
};

export const dmNganhRequestSuccess = function dmNganhRequestSuccess(dataList) {
  return {
    type: DM_NGANH_REQUEST_SUCCESS,
    dataList,
  };
};

export const dmNganhRequestError = function dmNganhRequestError(error) {
  return {
    type: DM_NGANH_REQUEST_ERROR,
    error,
  };
};


export const topInterestRequest = function topInterestRequest() {
  return {
    type: TOP_INTEREST_REQUESTING
  };
};

export const topInterestRequestSuccess = function topInterestRequestSuccess(dataList) {
  return {
    type: TOP_INTEREST_REQUEST_SUCCESS,
    dataList,
  };
};

export const topInterestRequestError = function topInterestRequestError(error) {
  return {
    type: TOP_INTEREST_REQUEST_ERROR,
    error,
  };
};

export const topVolumeRequest = function topVolumeRequest() {
  return {
    type: TOP_VOLUME_REQUESTING
  };
};

export const topVolumeSuccess = function topVolumeSuccess(resData) {
  return {
    type: TOP_VOLUME_SUCCESS,
    resData,
  };
};

export const topVolumeError = function topVolumeError(error) {
  return {
    type: TOP_VOLUME_ERROR,
    error,
  };
};